import { styled } from '@innowise-group/mui-kit';

export const Wrapper = styled.button`
  border: none;
  background: none;
  width: 100%;
`;
